/*
 * Anchor Autoworks: Make / Model / Year / (Engine) type-ahead vehicle picker, vehicle finder
 * and product "Will it fit?" check. Uses window.AnchorGarage (assets/anchor-garage.js) for the
 * cached vehicle index, saving the vehicle and building scoped URLs.
 *
 * Vehicle format everywhere: "Make|Model|StartYear-EndYear" with an optional "|Engine".
 */
(function () {
  if (window.AnchorFitment) return;
  var G = window.AnchorGarage;
  if (!G) return;

  var MAX_SHOWN = 8;
  var uid = 0;
  var cfg = G.config || {};
  var YEAR_MIN = cfg.year_min || 1980;
  var YEAR_MAX = cfg.year_max || new Date().getFullYear() + 1;

  function readJSON(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }
  function lc(s) {
    return String(s || '').trim().toLowerCase();
  }
  function uniq(arr) {
    return arr.filter(function (x, i) {
      return arr.indexOf(x) === i;
    });
  }
  /* Case-insensitive "contains" match, ranked: starts with > word starts with > contains */
  function rank(items, query) {
    var q = lc(query);
    if (!q) return items.slice();
    var scored = [];
    items.forEach(function (item) {
      var t = lc(item);
      var i = t.indexOf(q);
      if (i < 0) return;
      var score = i === 0 ? 0 : /[\s\-\/(]/.test(t.charAt(i - 1)) ? 1 : 2;
      scored.push([score, t.length, item]);
    });
    scored.sort(function (a, b) {
      return a[0] - b[0] || a[1] - b[1] || String(a[2]).localeCompare(String(b[2]));
    });
    return scored.map(function (s) {
      return s[2];
    });
  }
  function universalUrl() {
    return G.scopeUrl(cfg.shop_url || '/collections/all', 'universal', null);
  }

  /* ---------- Accessible combobox (WAI-ARIA 1.2 combobox with listbox popup) ---------- */
  function Combo(input, opts) {
    var self = this;
    this.input = input;
    this.opts = opts;
    this.popup = input.parentNode.querySelector('.combo__popup');
    this.list = this.popup.querySelector('[role="listbox"]');
    this.hint = this.popup.querySelector('[data-combo-hint]');
    this.items = [];
    this.active = -1;
    this.value = '';
    this.prefix = 'cb' + ++uid;

    input.addEventListener('input', function () {
      if (self.value && lc(self.input.value) !== lc(self.value)) self.commit('');
      self.input.removeAttribute('aria-invalid');
      self.open();
    });
    input.addEventListener('focus', function () {
      self.open();
    });
    input.addEventListener('click', function () {
      if (self.popup.hidden) self.open();
    });
    input.addEventListener('blur', function () {
      setTimeout(function () {
        if (self.popup.contains(document.activeElement)) return;
        self.acceptTyped();
        self.close();
      }, 120);
    });
    input.addEventListener('keydown', function (e) {
      var openNow = !self.popup.hidden;
      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          if (!openNow) self.open();
          self.move(1);
          break;
        case 'ArrowUp':
          e.preventDefault();
          if (!openNow) self.open();
          self.move(-1);
          break;
        case 'Enter':
          if (openNow && self.active > -1) {
            e.preventDefault();
            self.choose(self.active);
          } else if (openNow && self.items.length === 1) {
            e.preventDefault();
            self.choose(0);
          } else if (!self.acceptTyped() && self.input.value.trim()) {
            e.preventDefault();
          }
          break;
        case 'Escape':
          if (openNow) {
            e.preventDefault();
            self.close();
          } else if (self.input.value) {
            e.preventDefault();
            self.input.value = '';
            self.commit('');
          }
          break;
        case 'Tab':
          self.acceptTyped();
          self.close();
          break;
      }
    });
    // Keep focus in the input while clicking options or the hint link
    this.popup.addEventListener('mousedown', function (e) {
      if (!e.target.closest('a')) e.preventDefault();
    });
    this.list.addEventListener('click', function (e) {
      var li = e.target.closest('[role="option"]');
      if (li) self.choose(parseInt(li.getAttribute('data-index'), 10));
    });
  }
  Combo.prototype.open = function () {
    if (this.input.disabled) return;
    var all = this.opts.source();
    var q = this.input.value.trim();
    var matches = rank(all, q);
    this.items = matches.slice(0, MAX_SHOWN);
    this.active = -1;
    this.list.textContent = '';
    var self = this;
    this.items.forEach(function (item, i) {
      var li = document.createElement('li');
      li.id = self.prefix + '-opt-' + i;
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', 'false');
      li.setAttribute('data-index', String(i));
      li.className = 'combo__option';
      li.textContent = item;
      self.list.appendChild(li);
    });
    this.list.hidden = this.items.length === 0;
    this.hint.textContent = '';
    if (matches.length > MAX_SHOWN) {
      this.hint.textContent = 'Keep typing… ' + (matches.length - MAX_SHOWN) + ' more';
    } else if (!matches.length) {
      var msg = (this.opts.noMatch && this.opts.noMatch(q, all)) || null;
      if (msg) {
        this.hint.appendChild(document.createTextNode(msg.text));
        if (msg.href) {
          var a = document.createElement('a');
          a.href = msg.href;
          a.className = 'link';
          a.textContent = msg.link;
          this.hint.appendChild(document.createTextNode(' '));
          this.hint.appendChild(a);
        }
      }
    }
    this.hint.hidden = !this.hint.textContent;
    var show = this.items.length > 0 || !this.hint.hidden;
    this.popup.hidden = !show;
    this.input.setAttribute('aria-expanded', show && this.items.length ? 'true' : 'false');
    this.input.removeAttribute('aria-activedescendant');
  };
  Combo.prototype.close = function () {
    this.popup.hidden = true;
    this.active = -1;
    this.input.setAttribute('aria-expanded', 'false');
    this.input.removeAttribute('aria-activedescendant');
  };
  Combo.prototype.move = function (d) {
    if (!this.items.length) return;
    this.active = this.active < 0 ? (d > 0 ? 0 : this.items.length - 1) : (this.active + d + this.items.length) % this.items.length;
    var self = this;
    Array.prototype.forEach.call(this.list.children, function (li, i) {
      var on = i === self.active;
      li.setAttribute('aria-selected', on ? 'true' : 'false');
      li.classList.toggle('is-active', on);
      if (on) {
        self.input.setAttribute('aria-activedescendant', li.id);
        if (li.scrollIntoView) li.scrollIntoView({ block: 'nearest' });
      }
    });
  };
  Combo.prototype.choose = function (i) {
    var item = this.items[i];
    if (item == null) return;
    this.input.value = item;
    this.input.removeAttribute('aria-invalid');
    this.commit(String(item));
    this.close();
  };
  /* Accept typed text when it exactly (case-insensitively) matches an allowed value */
  Combo.prototype.acceptTyped = function () {
    var typed = this.input.value.trim();
    if (!typed) {
      this.input.removeAttribute('aria-invalid');
      if (this.value) this.commit('');
      return false;
    }
    var all = this.opts.source();
    for (var i = 0; i < all.length; i++) {
      if (lc(all[i]) === lc(typed)) {
        this.input.value = all[i];
        this.input.removeAttribute('aria-invalid');
        this.commit(String(all[i]));
        return true;
      }
    }
    if (!this.value) this.input.setAttribute('aria-invalid', 'true');
    return false;
  };
  Combo.prototype.commit = function (v) {
    if (v === this.value) return;
    this.value = v;
    if (this.opts.onCommit) this.opts.onCommit(v);
  };
  Combo.prototype.set = function (v) {
    this.input.value = v || '';
    this.value = v || '';
    this.input.removeAttribute('aria-invalid');
  };
  Combo.prototype.enable = function (on) {
    var inp = this.input;
    if (!inp.hasAttribute('data-placeholder')) inp.setAttribute('data-placeholder', inp.getAttribute('placeholder') || '');
    inp.disabled = !on;
    var ph = on ? inp.getAttribute('data-placeholder') : inp.getAttribute('data-disabled-placeholder') || inp.getAttribute('data-placeholder');
    if (inp.getAttribute('placeholder') !== ph) inp.setAttribute('placeholder', ph);
    if (!on) this.close();
  };

  /* ---------- Make -> Model -> Year -> (Engine) ---------- */
  function YMM(root, index, onChange) {
    var self = this;
    this.root = root;
    this.index = index;
    this.onChange = onChange || function () {};
    this.engineField = root.querySelector('[data-ymm-engine-field]');
    this.status = root.querySelector('[data-ymm-status]');
    var q = function (k) {
      return root.querySelector('[data-ymm="' + k + '"]');
    };
    function noModel(query) {
      return query ? { text: "We don't list parts for that model yet:", link: 'browse universal parts', href: universalUrl() } : null;
    }
    this.make = new Combo(q('make'), {
      source: function () {
        return Object.keys(self.index.makes)
          .map(function (k) { return self.index.makes[k].name; })
          .sort();
      },
      noMatch: noModel,
      onCommit: function () {
        self.model.set('');
        self.year.set('');
        self.engine.set('');
        self.sync();
        self.changed();
      },
    });
    this.model = new Combo(q('model'), {
      source: function () {
        var m = self.makeObj();
        return m
          ? Object.keys(m.models)
              .map(function (k) { return m.models[k].name; })
              .sort()
          : [];
      },
      noMatch: noModel,
      onCommit: function () {
        if (self.year.value && self.years().indexOf(self.year.value) < 0) self.year.set('');
        self.engine.set('');
        self.sync();
        self.changed();
      },
    });
    this.year = new Combo(q('year'), {
      source: function () {
        return self.years();
      },
      noMatch: function (query) {
        if (!query) return null;
        if (!/^\d+$/.test(query)) return { text: 'Enter a 4-digit year.' };
        if (query.length < 4) return { text: 'Keep typing the year…' };
        var y = parseInt(query, 10);
        if (y < YEAR_MIN || y > YEAR_MAX) return { text: 'Enter a year from ' + YEAR_MIN + ' to ' + YEAR_MAX + '.' };
        return { text: "We don't list parts for that model yet:", link: 'browse universal parts', href: universalUrl() };
      },
      onCommit: function () {
        if (self.engine.value && self.engines().indexOf(self.engine.value) < 0) self.engine.set('');
        self.sync();
        self.changed();
      },
    });
    this.year.input.addEventListener('input', function () {
      var clean = self.year.input.value.replace(/\D/g, '').slice(0, 4);
      if (clean !== self.year.input.value) self.year.input.value = clean;
    });
    this.engine = new Combo(q('engine'), {
      source: function () {
        return self.engines();
      },
      noMatch: function (query) {
        return query ? { text: 'No match. Leave it blank to see parts for any engine.' } : null;
      },
      onCommit: function () {
        self.changed();
      },
    });
    this.sync();
  }
  YMM.prototype.makeObj = function () {
    return this.index.makes[lc(this.make.value)] || null;
  };
  YMM.prototype.modelObj = function () {
    var m = this.makeObj();
    return m ? m.models[lc(this.model.value)] || null : null;
  };
  YMM.prototype.years = function () {
    var mo = this.modelObj();
    if (!mo) return [];
    var ys = [];
    mo.entries.forEach(function (v) {
      for (var y = Math.max(v.start, YEAR_MIN); y <= Math.min(v.end, YEAR_MAX); y++) ys.push(String(y));
    });
    return uniq(ys).sort(function (a, b) {
      return b - a;
    });
  };
  YMM.prototype.engines = function () {
    var mo = this.modelObj();
    if (!mo) return [];
    var y = parseInt(this.year.value, 10);
    return uniq(
      mo.entries
        .filter(function (v) {
          return v.engine && (!y || (v.start <= y && y <= v.end));
        })
        .map(function (v) {
          return v.engine;
        })
    ).sort();
  };
  YMM.prototype.sync = function () {
    this.model.enable(!!this.makeObj());
    this.year.enable(!!this.modelObj());
    var hasEngines = this.engines().length > 0;
    if (this.engineField) this.engineField.hidden = !hasEngines;
    this.engine.enable(hasEngines && !!this.year.value);
  };
  /* Called on submit: returns the vehicle, or shows what's missing and focuses that field */
  YMM.prototype.validate = function () {
    var v = this.value();
    var err = this.root.querySelector('[data-ymm-error]');
    if (v) {
      if (err) err.hidden = true;
      return v;
    }
    var missing = !this.makeObj() ? [this.make, 'Choose your make from the list.'] : !this.modelObj() ? [this.model, 'Choose your model from the list.'] : [this.year, 'Choose your model year.'];
    missing[0].input.setAttribute('aria-invalid', 'true');
    if (err) {
      err.textContent = missing[1];
      err.hidden = false;
    }
    missing[0].input.focus();
    return null;
  };
  YMM.prototype.changed = function () {
    var err = this.root.querySelector('[data-ymm-error]');
    if (err && !err.hidden && this.value()) err.hidden = true;
    var v = this.value();
    if (this.status) this.status.textContent = v ? 'Selected ' + G.label(v) : '';
    this.onChange(v);
  };
  YMM.prototype.value = function () {
    if (!this.makeObj() || !this.modelObj() || !this.year.value) return null;
    return {
      year: parseInt(this.year.value, 10),
      make: this.makeObj().name,
      model: this.modelObj().name,
      engine: this.engine.value || '',
    };
  };
  YMM.prototype.set = function (v) {
    if (!v) return;
    var m = this.index.makes[lc(v.make)];
    if (!m) return;
    this.make.set(m.name);
    this.sync();
    var mo = m.models[lc(v.model)];
    if (!mo) return this.changed();
    this.model.set(mo.name);
    this.sync();
    if (this.years().indexOf(String(v.year)) > -1) this.year.set(String(v.year));
    this.sync();
    if (v.engine && this.engines().indexOf(v.engine) > -1) this.engine.set(v.engine);
    this.sync();
    this.changed();
  };

  /* <vehicle-finder>: homepage / collection / garage panel.
     data-mode="finder" (default): save + go to the scoped collection.
     data-mode="garage": save; on collection/search pages re-scope the current page. */
  if (!customElements.get('vehicle-finder')) {
    customElements.define(
      'vehicle-finder',
      class extends HTMLElement {
        connectedCallback() {
          if (this._ready) return;
          this._ready = true;
          var self = this;
          this.form = this.querySelector('form');
          this.button = this.querySelector('[type="submit"]');
          this.base = this.getAttribute('data-collection-url') || cfg.shop_url || '/collections/all';
          this.mode = this.getAttribute('data-mode') || 'finder';
          if (!this.form || !this.querySelector('[data-ymm-root]')) return;
          this.form.addEventListener('submit', function (event) {
            event.preventDefault();
            if (!self.ymm) return;
            var sel = self.ymm.validate();
            if (!sel) return;
            var saved = G.save(sel, self.index.list);
            if (self.mode === 'garage') {
              G.closePanel();
              if (G.isScopablePage()) window.location.href = G.scopeUrl(window.location.href, 'both', saved);
              return;
            }
            window.location.href = G.scopeUrl(self.base, 'both', saved);
          });
          G.loadVehicles().then(function (index) {
            self.index = index;
            self.ymm = new YMM(self, index);
            self.ymm.set(G.load());
          });
        }
      }
    );
  }

  /* <fit-check>: product page "Will it fit my vehicle?" */
  if (!customElements.get('fit-check')) {
    customElements.define(
      'fit-check',
      class extends HTMLElement {
        connectedCallback() {
          if (this._ready) return;
          this._ready = true;
          var self = this;
          var data = readJSON(this.querySelector('[data-fit-data]')) || {};
          this.fits = G.parseList(data.fitment || []);
          this.universal = !!data.universal;
          this.result = this.querySelector('[data-fit-result]');
          this.msg = data.messages || {};
          G.loadVehicles().then(function (index) {
            var all = index.list.concat(self.fits);
            if (!all.length) return;
            self.index = G.buildIndex(all);
            self.ymm = new YMM(self, self.index, function (v) {
              self.render(v, true);
            });
            var saved = G.load();
            if (saved) self.ymm.set(saved);
          });
        }
        render(sel, persist) {
          if (!this.result) return;
          this.result.hidden = !sel;
          this.result.className = 'fit-check__result';
          if (!sel) return;
          if (persist) G.save(sel, this.index.list);
          var name = G.label(sel);
          if (this.universal) {
            this.result.classList.add('fit-check__result--yes');
            this.result.textContent = (this.msg.universal || '').replace('[vehicle]', name);
            return;
          }
          if (G.fits(this.fits, sel)) {
            this.result.classList.add('fit-check__result--yes');
            this.result.textContent = (this.msg.fits || '').replace('[vehicle]', name);
            return;
          }
          this.result.classList.add('fit-check__result--no');
          this.result.textContent = (this.msg.no_fit || '').replace('[vehicle]', name) + ' ';
          if (this.msg.contact_url && this.msg.contact_label) {
            var a = document.createElement('a');
            a.href = this.msg.contact_url;
            a.textContent = this.msg.contact_label;
            this.result.appendChild(a);
          }
        }
      }
    );
  }

  window.AnchorFitment = { YMM: YMM, Combo: Combo, rank: rank };
})();
